import { Link } from "@tanstack/react-router";

/**
 * Landing-page footer: copyright on the left, company and legal links on the
 * right, then the legal disclaimer.
 */
export function MarketingFooter() {
  return (
    <footer className="w-full border-t border-withus-dark-blue bg-withus-white px-4 py-5 md:px-8">
      <div className="flex flex-col items-center justify-between gap-4 text-sm text-withus-dark-blue md:flex-row">
        <span>© 2026 With Studios, Inc</span>
        <nav className="flex items-center gap-6" aria-label="Footer">
          <Link to="/about-us" className="transition-opacity hover:opacity-70">
            About us
          </Link>
          <Link to="/faq" className="transition-opacity hover:opacity-70">
            FAQ
          </Link>
          <Link to="/terms" className="transition-opacity hover:opacity-70">
            Terms
          </Link>
          <Link to="/privacy" className="transition-opacity hover:opacity-70">
            Privacy
          </Link>
          <Link to="/disclosures" className="transition-opacity hover:opacity-70">
            Disclosures
          </Link>
        </nav>
      </div>
      <div className="mt-4 border-withus-dark-blue/20 pt-4 text-xs text-withus-dark-blue/60">
        <section className="mb-2 space-y-4">
          <DisclaimerParagraphs />
        </section>
        <p>
          By using the Site, you agree to the{" "}
          <Link to="/terms" className="underline transition-opacity hover:opacity-70">
            WITH.CO Terms of Service
          </Link>{" "}
          (which require that disputes be resolved through binding arbitration) and{" "}
          <Link to="/privacy" className="underline transition-opacity hover:opacity-70">
            Privacy Policy
          </Link>
          . For more information about our site and offerings, you should review our{" "}
          <Link to="/disclosures" className="underline transition-opacity hover:opacity-70">
            Important Disclosures
          </Link>
          .
        </p>
      </div>
    </footer>
  );
}

export function DisclaimerParagraphs() {
  return (
    <>
      <p>
        None of the information on our website (“Site”) should be construed as investment,
        financial, tax, or legal advice.
      </p>

      <p>
        Information on the Site has been prepared by With Studios Inc. (“WITH.CO”) without reference
        to any particular individual’s investment goals or financial situation and may contain
        summary information relating to potential or proposed WITH.CO offerings. Any such
        information is preliminary, subject to change, and will be qualified in its entirety by
        reference to the more detailed discussions contained in the respective offering circular, if
        and when filed with the Securities and Exchange Commission (“SEC”) or other offering
        materials relating to such Offering. You are encouraged to consult with tax, legal, and
        financial professionals before investing in an Offering. YOU SHOULD CAREFULLY REVIEW THE
        RELEVANT WITH.CO OFFERING CIRCULAR BEFORE DECIDING TO INVEST, A COPY OF WHICH WILL BE
        AVAILABLE ON THE SITE, OR ON THE SEC’S{" "}
        <a
          href="https://www.sec.gov/search-filings"
          target="_blank"
          rel="noopener noreferrer"
          className="underline transition-opacity hover:opacity-70"
        >
          EDGAR WEBSITE
        </a>
        .
      </p>
      <p>
        For any proposed offering pursuant to an offering statement that has not yet been qualified
        by the SEC, no money or other consideration is being solicited at this time, and if sent,
        will not be accepted. No offer to buy the securities can be accepted and no part of the
        purchase price can be received until an offering statement on Form 1-A for such offering has
        been filed with and qualified by the SEC. Any such offer may be withdrawn or revoked,
        without obligation or commitment of any kind, at any time before notice of acceptance is
        given after the qualification date. Any indication of interest involves no obligation or
        commitment of any kind.
      </p>
      <p>
        WITH.CO and its affiliates are “testing the waters” under Regulation A of the Securities Act
        of 1933 to determine whether there may be interest in a potential offering of securities.
        This communication is for solicitation-of-interest purposes only, and we are under no
        obligation to make an offering under Regulation A. WITH.CO can only make sales after an
        offering statement has been filed, and “qualified” by, the Securities and Exchange
        Commission (“SEC”). As such, no offer consideration is currently being solicited or accepted
        and any such offers may be withdrawn or revoked, without obligation, at any time before
        notice of SEC qualification. An indication of interest involves no obligation. You must read
        the offering documents filed with the SEC before investing.
      </p>
    </>
  );
}
